import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiExternalLink } from 'react-icons/fi';
import { colors } from '../theme/colors';
import { navigateToTransaction } from '../utils/navigationHelper';

/**
 * Renders a parent transaction's docNumber as a clickable link that opens
 * the source document. Usage:
 *   <ParentDocLink parentDocNumber={t.parentDocNumber}
 *                  parentTranType={t.parentTranType}
 *                  parentId={t.parentId} />
 *
 * Falls back to "Direct" when there's no parent.
 */
const ParentDocLink = ({ parentDocNumber, parentTranType, parentId, fallback = 'Direct' }) => {
  const navigate = useNavigate();

  if (!parentDocNumber) {
    return <span style={{ color: colors.text.tertiary, fontStyle: 'italic' }}>{fallback}</span>;
  }

  // If we don't have enough info to navigate, render plain text
  if (!parentId || !parentTranType) {
    return <span>{parentDocNumber}</span>;
  }

  const handleClick = (e) => {
    e.stopPropagation();
    navigateToTransaction(navigate, parentTranType, parentId);
  };

  return (
    <span
      onClick={handleClick}
      style={{
        cursor: 'pointer',
        color: colors.primary.main,
        fontWeight: 500,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
      }}
      onMouseEnter={(e) => { e.currentTarget.style.textDecoration = 'underline'; }}
      onMouseLeave={(e) => { e.currentTarget.style.textDecoration = 'none'; }}
      title={`Open ${parentTranType} ${parentDocNumber}`}
    >
      {parentDocNumber}
      <FiExternalLink size={11} />
    </span>
  );
};

export default ParentDocLink;
